import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const CustomerCommunicationWizardRoute: RouteType = {
  name: "CustomerCommunicationWizard",
  path: "/workflows/customer-communication",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Customer Communication Log",
      component: () => import("./CustomerCommunicationWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./CustomerCommunicationWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const commentsStore = rootStore.commentsStore as ServiceStore;
      const emailHistoryStore = rootStore.emailHistoryStore as ServiceStore;
      const activitiesStore = rootStore.activitiesStore as ServiceStore;
      const contactsStore = rootStore.contactsStore as ServiceStore;

      await Promise.all([
        commentsStore?.find(),
        emailHistoryStore?.find(),
        activitiesStore?.find(),
        contactsStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for customer communication:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).customerCommunicationWizardStore;
    store?.reset();
  },
};

export default CustomerCommunicationWizardRoute;